import React from "react";
import { Table } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import FooterPagination from "../../Pagination/FooterPagination";
import { textRoles } from "../../../constants";
import UserStatusBadge from "../../Badges/UserStatusBadge";
import DropdownMenuActions from "../../Dropdown/DropdownMenuActions";
import { resentInvitation } from "../../../slices/general/thunk";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const BrokersTable = ({ data, searchParam, searchDone, paginationProps }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { role, id } = useParams();
  const isNotSearchResult = searchParam && !data.length && searchDone;
  const noData = data.length === 0 && !searchParam;

  const handleViewProfile = (id) => {
    const route = `/brokers/${id}`;
    navigate(route);
  };

  const handleRowClick = (userId, event) => {
    const selection = window.getSelection().toString();
    if (!selection) {
      navigate(`/brokers/${userId}`);
    }
  };

  const handleResendInvitation = async (userId) => {
    try {
      const response = await dispatch(resentInvitation({ userId }));

      const res = response.payload;

      if (res && !res.error) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Invitation has been resent successfully",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Invitation could not be resent",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Invitation could not be resent",
      });
      console.log(error);
    }
  };

  return (
    <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
      <thead className="bg" style={{ background: "var(--thead-bg)" }}>
        <tr>
          <th scope="col">Broker Name</th>
          <th scope="col">Contact</th>
          <th scope="col">Number of Employer Groups</th>
          {id && role ? "" : <th scope="col">Number of Employees</th>}
          <th>Status</th>
          <th scope="col" className="text-center">
            Manage
          </th>
        </tr>
      </thead>
      <tbody>
        {isNotSearchResult && (
          <tr>
            <td className="text-center" colSpan="5">
              No search results for "{searchParam}"
            </td>
          </tr>
        )}

        {noData ? (
          <tr>
            <td className="text-center" colSpan="5">
              {id && role
                ? `${textRoles[role]} has no Brokers yet.`
                : "You have no Brokers yet."}
            </td>
          </tr>
        ) : (
          data.map((broker, index) => (
            <tr
              key={index}
              onClick={(event) => handleRowClick(broker.id, event)}
              className="cursor-pointer"
            >
              <td>
                {broker.firstName || broker.lastName
                  ? `${broker.firstName || ""} ${broker.lastName || ""}`.trim()
                  : broker.id}
              </td>
              <td>{broker.email}</td>
              <td>{broker.employersCount || "0"}</td>
              {id && role ? "" : <td>{broker.employeesCount || "0"}</td>}
              <td>
                <UserStatusBadge
                  status={broker.firstLogin ? "Active" : "Invited"}
                  color={broker.firstLogin ? "success" : "warning"}
                />
              </td>
              <td className="text-center">
                <DropdownMenuActions
                  onViewProfile={handleViewProfile}
                  onResendInvitation={handleResendInvitation}
                  item={broker}
                  status={broker.firstLogin ? "Active" : "Invited"}
                />
              </td>
            </tr>
          ))
        )}
      </tbody>
      {paginationProps.totalItems > 0 && (
        <tfoot>
          <FooterPagination {...paginationProps} />
        </tfoot>
      )}
    </Table>
  );
};

export default BrokersTable;
